import { render, staticRenderFns } from "./procurement_return.vue?vue&type=template&id=10a571fc"
import script from "./procurement_return.vue?vue&type=script&lang=js"
export * from "./procurement_return.vue?vue&type=script&lang=js"
import style0 from "./procurement_return.vue?vue&type=style&index=0&id=10a571fc&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports